import { cn, formatCurrency } from '@/lib/utils'

interface CreditLineItem {
  description: string
  value: number
}

interface CreditLineSimulationProps {
  items: CreditLineItem[]
  title?: string
  className?: string
}

export function CreditLineSimulation({
  items,
  title = 'Credit Line Simulation',
  className,
}: CreditLineSimulationProps) {
  const maxValue = Math.max(...items.map((i) => i.value))

  return (
    <div className={cn('bg-white rounded-lg border p-4', className)}>
      <h4 className="text-sm font-semibold text-gray-700 mb-3">{title}</h4>
      <div className="space-y-3">
        {items.map((item, index) => {
          const percentage = (item.value / maxValue) * 100
          return (
            <div key={index} className="space-y-1">
              <div className="flex items-center justify-between text-xs">
                <span className="text-gray-600 truncate flex-1 mr-2">{item.description}</span>
                <span className="font-semibold text-dashboard-navy shrink-0">
                  {formatCurrency(item.value)}
                </span>
              </div>
              <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-dashboard-teal to-dashboard-purple rounded-full transition-all duration-500"
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
